import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

const searchStore = create(set => ({
  searchJson: {},
  setSearchJson: data => set(() => ({ searchJson: data })),
}));

const useAccordionStore = create(
  devtools(
    set => ({
      activeAccordions: [],
      addAccordion: title => set(state => state.activeAccordions.push(title)),
      removeAccordion: title => set(state => ({
        activeAccordions: state.activeAccordions.filter(
          accTitle => accTitle !== title,
        ),
      })),
    }),
    {
      name: 'Accordion',
    },
  ),
);

export { searchStore, useAccordionStore };
